import { some } from "lodash-es";
export function massageTickSpacing(spacing) {
  let toRet = spacing;
  if (spacing < 15) {
    return 10;
  }
  some(
    [20, 50, 100, 500, 1e3, 2e3, 5e3, 1e4, 5e4, 1e5, 1e6],
    (val) => {
      if (spacing < val) {
        toRet = val;
        return true;
      }
    }
  );
  return toRet;
}
